/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const Container = styled.small({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
});

export const Spinner = styled.div({
  margin: `${gridSize()}px 0`,
});
